function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import { withStyles } from '@mui-treasury/styling';
import Typography from '@material-ui/core/Typography';
const TextInfoCardContent = withStyles({
  overline: {},
  heading: {},
  body: {}
}, {
  name: 'TextInfo'
})(({
  css,
  overline,
  heading,
  body,
  overlineProps,
  headingProps,
  bodyProps
}) => React.createElement(React.Fragment, null, overline && React.createElement(Typography, _extends({
  component: 'span'
}, overlineProps, {
  className: cx(css.overline, overlineProps.className)
}), overline), React.createElement(Typography, _extends({
  component: 'h4'
}, headingProps, {
  className: cx(css.heading, headingProps.className)
}), heading), React.createElement(Typography, _extends({}, bodyProps, {
  className: cx(css.body, bodyProps.className)
}), body)));
TextInfoCardContent.propTypes = {
  overline: PropTypes.node,
  heading: PropTypes.node,
  body: PropTypes.node,
  overlineProps: PropTypes.shape({}),
  headingProps: PropTypes.shape({}),
  bodyProps: PropTypes.shape({})
};
TextInfoCardContent.defaultProps = {
  overline: null, 
  heading: null,
  body: null,
  overlineProps: {},
  headingProps: {},
  bodyProps: {}
};
export default TextInfoCardContent;